import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { Button, Breadcrumb, Switch } from 'element-react'
import FeatureFlagDialog from './includes/FeatureFlagDialog'
import Spacer from '../views/includes/Spacer'
import { MainSection } from '../views/includes/Wrappers'
import CustomLoader from '../user/includes/CustomLoader'
import useAdmin from '../../hooks/useAdmin'
import AppRoutes from '../../routes/appRoutes'

const ManageFeatureFlags = props => {
    const [features, setFeatures] = useState([])

    const [showDialog, setShowDialog] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [singleFeature, setSingleFeature] = useState({})
    const { handleToggleFeature, handleLoadFeatureFlags } = useAdmin()

    const closeDialog = () => {
        setShowDialog(false)
    }

    const handleToggleFeatureSuccess = res => {
        setFeatures(res?.data?.features)
        closeDialog()
    }

    const handleLoadedFeatures = res => {
        const data = res.data.feature_flags
        setIsLoading(false)
        setFeatures(data)
    }

    useEffect(() => {
        setIsLoading(true)
        handleLoadFeatureFlags(handleLoadedFeatures)
    }, [])

    const goBack = () => {
        props.history.goBack()
    }

    const toggleFeature = () => {
        const feature = singleFeature
        handleToggleFeature(feature, handleToggleFeatureSuccess, () => {
            closeDialog()
        })
    }

    const checkFeatureFlags = () => {
        handleLoadFeatureFlags(res => {
            const data = res.data.feature_flags
            setFeatures(data)
        })
    }

    const showDialogModal = feature => {
        setShowDialog(true)
        setSingleFeature(feature)
    }

    const cancelRequest = () => {
        closeDialog()
        checkFeatureFlags()
    }

    return (
        <MainSection className="admin--add-user">
            <div className="row">
                <div className="columns medium-9">
                    {/* Breadcrumbs */}
                    <Breadcrumb separator="/" className="margin-top-small">
                        <Breadcrumb.Item>
                            <Link to={AppRoutes.home()}>Home</Link>
                        </Breadcrumb.Item>
                        <Breadcrumb.Item>Feature flagging</Breadcrumb.Item>
                    </Breadcrumb>
                </div>
                <div className="columns medium-3 show-for-medium">
                    {/* Back Button */}
                    <Button
                        type="text"
                        onClick={goBack}
                        className="button-back margin-top-small"
                    >
                        <i className="icon-chevron-thin-left"></i> Go Back
                    </Button>
                </div>
            </div>
            <div className="row">
                <div className="small-12 columns">
                    <Spacer size="small" />

                    <h3>Feature flags</h3>
                    <p>
                        Toggle the buttons to turn ON and OFF the selected
                        features for all users.
                    </p>
                    <Spacer size="tiny" />
                    {features.map(feature => (
                        <div className="row" key={`row-${feature.id}`}>
                            <div className="small-8 columns ">
                                <h5>{feature.name}</h5>
                            </div>
                            <div className="small-4 columns margin-top-tiny">
                                <Switch
                                    value={feature.active}
                                    onChange={() => {
                                        showDialogModal(feature)
                                    }}
                                ></Switch>
                            </div>
                            <Spacer size="tiny" />
                        </div>
                    ))}
                </div>
            </div>
            {isLoading && (
                <div className="demo-loading padding-top-large padding-bottom-large">
                    {' '}
                    <CustomLoader text="Loading Service Request" />
                </div>
            )}
            <FeatureFlagDialog
                show={showDialog}
                feature={singleFeature}
                cancel={cancelRequest}
                featureFlagging={toggleFeature}
            />
        </MainSection>
    )
}

ManageFeatureFlags.propTypes = {
    history: PropTypes.shape({
        goBack: PropTypes.func,
    }),
}

export default ManageFeatureFlags
